<template>
  <div>
    <van-nav-bar
      :title="generateCustomizeString('orderList')"
      @click-right="onClickRight"
      @click-left="onClickLeft"
      :sticky="true"
      fixed
    >
      <!-- <van-uploader :after-read="onRead" accept="image/gif, image/jpeg" slot="left">
        <van-icon name="aim" />
      </van-uploader>-->
      <!-- <van-icon name="aim" slot="left" /> -->
      <img slot="left" :src="scan" style="width: 18px; vertical-align: middle;" />
      <van-icon name="search" size="20px" slot="right" />
    </van-nav-bar>

    <van-tabs class="orders-tabs" v-model="activeTab" sticky :line-width="65" :offset-top="44">
      <van-tab :title="generateCustomizeString('allOrders')" v-if="this.orderMenuList.length === 9">
        <order-list :isOrderStatus="-1"></order-list>
      </van-tab>
      <div v-for="order in orderMenuList" :key="order.value">
        <van-tab :title="order.name">
          <order-list :isOrderStatus="order.value"></order-list>
        </van-tab>
      </div>
      <!-- <van-tab title="未付款">
        <order-list :isOrderStatus="0"></order-list>
      </van-tab>
      <van-tab title="部分付款">
        <order-list :isOrderStatus="5"></order-list>
      </van-tab>
      <van-tab title="已付款">
        <order-list :isOrderStatus="10"></order-list>
      </van-tab>
      <van-tab title="配货中">
        <order-list :isOrderStatus="15"></order-list>
      </van-tab>
      <van-tab title="已发货">
        <order-list :isOrderStatus="20"></order-list>
      </van-tab>
      <van-tab title="申请退款">
        <order-list :isOrderStatus="50"></order-list>
      </van-tab>
      <van-tab title="退款完成">
        <order-list :isOrderStatus="60"></order-list>
      </van-tab>
      <van-tab title="交易完成">
        <order-list :isOrderStatus="40"></order-list>
      </van-tab>
      <van-tab title="已关闭">
        <order-list :isOrderStatus="99"></order-list>
      </van-tab>-->
    </van-tabs>
  </div>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import { Uploader, Icon, NavBar, Tabbar, TabbarItem, Tab, Tabs } from 'vant'
import OrderList from './components/OrderList'
import wxConfig from '@/utils/wxConfig'
import scan from '@/assets/scan.png'
import store from '@/store'

export default {
  name: 'orders',
  components: {
    [Uploader.name]: Uploader,
    [Icon.name]: Icon,
    [NavBar.name]: NavBar,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    OrderList
  },
  data() {
    return {
      active: 0,
      activeTab: 0,
      code: 'xxx',
      scan: scan,
      orderMenuList: [],
      // OrderMenuName: ['Unpaid', 'PartUnpaid', 'Paid', 'Picking', 'Shipped', 'RequestRefund', 'Completed', 'RefundFinished', 'Closed']
      OrderMenuName: [
        {
          status: 'Unpaid',
          name: this.generateCustomizeString('unpaid'),
          value: 0
        },
        {
          status: 'PartUnpaid',
          name: this.generateCustomizeString('partialyPaid'),
          value: 5
        },
        {
          status: 'Paid',
          name: this.generateCustomizeString('paid'),
          value: 10
        },
        {
          status: 'Picking',
          name: this.generateCustomizeString('picking'),
          value: 15
        },
        {
          status: 'Shipped',
          name: this.generateCustomizeString('shipped'),
          value: 20
        },
        {
          status: 'Completed',
          name: this.generateCustomizeString('completed'),
          value: 40
        },
        {
          status: 'RequestRefund',
          name: this.generateCustomizeString('requestRefund'),
          value: 50
        },
        {
          status: 'RefundFinished',
          name: this.generateCustomizeString('refundFinished'),
          value: 60
        },
        {
          status: 'Closed',
          name: this.generateCustomizeString('closed'),
          value: 90
        }
      ]
    }
  },
  mounted: function() {},
  methods: {
    generateCustomizeString,
    onRead(file) {
      console.log(file)
    },
    onClickLeft() {
      const that = this
      wxConfig.scanQRCode().then(key => {
        const params = { fromHome: 1, key: key }
        that.$router.push({ name: 'Search', params: params })
      })
      // wxConfig.scanCode(function(res) {
      //   const result = res.resultStr
      //   const resultArr = result.split(',')
      //   const key = resultArr[1]
      //   // that.searchKey = key
      //   // that.$refs.orderList.fetchDataUseKeyword(that.searchKey)
      // const params = { fromHome: 1, key: key }
      // that.$router.push({ name: 'Search', params: params })
      // })
    },
    onClickRight() {
      // this.$barcodeScanner.init(this.onBarcodeScanned)
      // var _this = this
      // wx.ready(function() {
      //   wx.scanQRCode({
      //     needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
      //     scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
      //     success: function(res) {
      //       var result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
      //       var resultArr = result.split(',')
      //       console.log(resultArr)
      //     }
      //   })
      //   wx.error(function(res) {
      // // var str = JSON.stringify(res)

      //     console.log('config信息验证失败')
      //   })
      // })
      this.$router.push({ name: 'Search' })
    },
    onBarcodeScanned(barcode) {
      console.log(barcode)
      // do something...
    },
    initOrderMenu() {
      for (var j = 0; j < this.OrderMenuName.length; j++) {
        if (store.getters.menu.includes(this.OrderMenuName[j].status)) {
          this.orderMenuList.push(this.OrderMenuName[j])
        }
      }
    }
  },
  created: function() {
    // Add barcode scan listener and pass the callback function
    // this.RegisterWxJsApi()
    // wxConfig.config()
    this.initOrderMenu()
  },
  destroyed: function() {
    // Remove listener when component is destroyed
    // this.$barcodeScanner.destroy()
  }
}
</script>

<style lang="less" scoped>
.orders-tabs {
  // position: fixed;
  // width: 100%;
  // top: 0;
  // z-index: -1;
  margin-top: 44px;
  margin-bottom: 46px;
}
</style>
